import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "page-wrapper" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "rechargeDataSet"
}
const _hoisted_5 = {
  key: 1,
  class: "rechargeDataSet"
}
const _hoisted_6 = {
  key: 2,
  class: "flowLogDataSet"
}
const _hoisted_7 = {
  key: 4,
  class: "no_more"
}
const _hoisted_8 = { key: 1 }

import { onMounted, ref } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';
import { FundHistoryData, setRechargeStatus, setWithdrawStatus } from '@/view/fundHistory/supportScript';
import CustomDataRow from './components/customDataRow.vue';
import NoData from '../components/common/noDataCustom.vue';
import FlowLogCard from './components/flowLogCard.vue';
import { useRoute, useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'fundHistory',
  props: {
    dataSet: {},
    isTabView: { type: Boolean }
  },
  emits: ['onClickTab', 'getNextPageList'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const router = useRouter()
const active = ref(props.dataSet.active);
const route = useRoute()
const emits = __emit

const onClickTab = (active: any) => {
    emits('onClickTab', active)
}
const getNextPageList = () => {
    emits('getNextPageList')
}
const navToBack = () => {
    if (Number(route.query.tabIndex) == 0) {
        router.replace({ path: '/sd-topup', query: { tabIndex: 0 } })
    } else if (Number(route.query.tabIndex) == 1) {
        router.replace({ path: '/sd-withdraw', query: { tabIndex: 1 } })
    } else {
        router.go(-1)
    }
}
onMounted(() => {
    if (route.query.tabIndex) {
        active.value = Number(route.query.tabIndex) === 0 ? 2 : 3
    }
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isTabView)
      ? (_openBlock(), _createBlock(CustomHeader, {
          key: 0,
          text: _ctx.$t('profile.fundHistory'),
          "is-popup-close-back-icon": true,
          onClosePopup: navToBack
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "container",
      style: _normalizeStyle({paddingTop : _ctx.isTabView ? '' : '70px'})
    }, [
      _createVNode(_component_van_tabs, {
        active: active.value,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
        sticky: "",
        ellipsis: false,
        onClickTab: onClickTab
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.tabList, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_tab, {
              key: index,
              title: _ctx.$t(item.name),
              name: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.dataSet?.dataLog?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (item.id == 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.dataLog, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createVNode(CustomDataRow, {
                                    "card-data": item,
                                    status: _unref(setRechargeStatus)(item.status),
                                    class: _normalizeClass(index % 2 === 0 ? 'row-dark' : 'row-light')
                                  }, null, 8, ["card-data", "status", "class"])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (item.id == 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.dataLog, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createVNode(CustomDataRow, {
                                    "card-data": item,
                                    status: _unref(setWithdrawStatus)(item.status),
                                    class: _normalizeClass(index % 2 === 0 ? 'row-dark' : 'row-light')
                                  }, null, 8, ["card-data", "status", "class"])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (item.id == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.dataLog, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createVNode(FlowLogCard, {
                                    "card-data": item,
                                    class: _normalizeClass(index % 2 === 0 ? 'row-dark' : 'row-light')
                                  }, null, 8, ["card-data", "class"])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.dataSet.total > _ctx.dataSet.pageSize * _ctx.dataSet.pageNum)
                          ? (_openBlock(), _createBlock(_component_van_row, { key: 3 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_col, {
                                  span: "24",
                                  class: "arrowDown"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: _imports_0,
                                      alt: "",
                                      onClick: getNextPageList
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('common.NoMoreData')), 1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(NoData)
                      ]))
                ])
              ]),
              _: 2
            }, 1032, ["title", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["active"])
    ], 4)
  ]))
}
}

})